import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import topTitle from '@/components/title';
import { mailingDetail, consigneeResource, mailingInfo, consigneeDefault, delConsignee } from './../request';
import { documentColumns, consigneeListColumns, logisticsSelectList } from './../utils';
import consigneeModel from './consigneeModel.vue';
export default {
  components: {
    topTitle,
    consigneeModel
  },
  props: {
    claimsId: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      documentColumns,
      consigneeListColumns,
      previewVisible: false,
      infoData: {},
      consigneeList: [],
      selectedRowKeysArray: [],
      consigneeShow: false,
      logisticsSelectList,
      mailingInfo: {}
    };
  },
  created() {
    setTimeout(() => {
      this.init();
    }, 400);
  },
  computed: {
    dataRule() {
      return {
        logisticsCompany: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请选择') + this.$t('物流公司')
        }],
        shipmentNum: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('运单号')
        }]
      };
    }
  },
  methods: {
    async init() {
      // this.claimsId=id;
      this.infoData = await mailingDetail({
        claimsId: this.claimsId
      });
      this.consigneeList = await consigneeResource({});
      let arr = this.consigneeList.filter(item => item.isDefault);
      if (arr.length == 0) {
        this.selectedRowKeysArray = this.consigneeList.length == 0 ? [] : [this.consigneeList[0].consigneeId];
      } else {
        this.selectedRowKeysArray = [arr[0].consigneeId];
      }
      this.previewVisible = true;
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeysArray = selectedRowKeys;
    },
    handleSure() {
      this.$refs.from.validate(valid => {
        if (valid) {
          let obj = {
            claimsId: this.infoData.claimsId,
            consigneeId: this.selectedRowKeysArray[0]
          };
          Object.assign(obj, this.mailingInfo);
          mailingInfo(obj).then(res => {
            this.$message.success(this.$t('添加成功'));
            this.$emit('ok', res);
          });
        }
      });
    },
    addConsigneeFun() {
      this.consigneeShow = true;
      this.$nextTick(() => {
        this.$refs.consigneeForm.init(this.id);
      });
    },
    async consigneeFun(val, type) {
      if (val) {
        this.selectedRowKeysArray = [val];
        this.consigneeShow = false;
      }
      this.consigneeList = await consigneeResource({});
      if (type == 1) {
        let arr = this.consigneeList.filter(item => item.isDefault);
        this.selectedRowKeysArray = [arr[0].consigneeId];
      } else {
        let arr = this.consigneeList.filter(item => item.consigneeId == this.selectedRowKeysArray[0]);
        if (arr.length == 0) {
          this.selectedRowKeysArray = this.consigneeList.length == 0 ? [] : [this.consigneeList[0].consigneeId];
        } else {
          this.selectedRowKeysArray = [arr[0].consigneeId];
        }
      }
    },
    handleDefault(id) {
      consigneeDefault({
        consigneeId: id,
        default: 1
      }).then(res => {
        this.$message.success(this.$t('操作成功'));
        let arr = this.consigneeList.filter(item => item.isDefault);
        this.selectedRowKeysArray = [arr[0].consigneeId];
        this.consigneeFun(false, 1);
      });
    },
    handleDel(id) {
      delConsignee({
        consigneeId: id
      }).then(res => {
        this.$message.success(this.$t('删除成功'));
        this.consigneeFun(false, 2);
      });
    }
  }
};